export type Purchase = {
  name: string
  city: string
  state: string
}

/**
 * Vacío a propósito: las notificaciones solo se muestran con compras reales.
 * Cargá acá compradores verificados (nombre de pila + inicial, ciudad) y el
 * aviso se activa solo.
 */
export const recentPurchases: Purchase[] = []
